"use client"

import styled from "@emotion/styled"
import { Box, Typography } from "@mui/material"
import Image from "next/image"
import { useInView } from "react-intersection-observer"
import { useInViewConfig, useTransitionUpStyles } from "ui"
import { colors } from "ui/theme/theme"
import { StyledResultContainer } from "./FailureState"

const StyledImageWrapper = styled(Box)`
  position: relative;
  width: 229px;
  height: 182px;
`

const StyledTitle = styled(Typography)`
  font-size: 18px;
  color: ${colors.black};
  font-weight: 700;
`

const StyledText = styled(Typography)`
  font-size: 16px;
  color: ${colors.black};
  font-weight: 400;
`

interface SuccessStateProps {
  data: {
    successImage: {
      mediaItems: Array<{
        url: string
      }>
    }
    successTitle: {
      value: string
    }
    successText: {
      value: string
    }
  }
}

const SuccessState = ({ data }: SuccessStateProps) => {
  const { ref, inView } = useInView(useInViewConfig)
  const transitionStyles = useTransitionUpStyles(inView)
  const { successImage, successTitle, successText } = data

  return (
    <StyledResultContainer ref={ref} style={transitionStyles}>
      {successImage?.mediaItems?.length > 0 && (
        <StyledImageWrapper>
          <Image
            src={successImage?.mediaItems[0]?.url}
            alt="Success"
            fill
            style={{ objectFit: "contain" }}
          />
        </StyledImageWrapper>
      )}
      {successTitle?.value && <StyledTitle>{successTitle.value}</StyledTitle>}
      {successText?.value && <StyledText>{successText.value}</StyledText>}
    </StyledResultContainer>
  )
}

export default SuccessState
